import { createContext } from 'react';

export const IncentivesContext = createContext({});
